import "./MyAccount.module.css";
import Header from "@/reusable_sections/Header";
import Account from "./sections/Account";
export default function MyAccountPage() {
  return <div>
      <Header />
      <Account />
    </div>;
}